module.exports = __webpack_public_path__ + "img/base_model2.f62749d2.jpg";